module.exports = __webpack_public_path__ + "img/icon-review-success.7fde5101.png";